import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { of, Subject, switchMap, throwError } from 'rxjs';
import { EDIT, NO_VIEW, VIEW } from 'SharingApp/ts/constants';
import { PublicSharingState } from 'SharingApp/ts/enums/public-sharing-state.enum';
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
import { SharingService } from 'SharingApp/ts/services/sharing.service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import { isPublicShareableItem } from 'SharingApp/ts/utils/public-sharing-utils';
import { isMinimalShareableItem } from 'SharingApp/ts/utils/sharing-utils';
import * as i0 from "@angular/core";
import * as i1 from "SharingApp/ts/services/sharing.service";
import * as i2 from "NewAngular/features/components/toast-messages/page-toast-messages-service";
import * as i3 from "@angular/common";
import * as i4 from "../confirm-modal/confirm-modal.component";
import * as i5 from "../../../directives/disabled/disabled.directive";
import * as i6 from "@angular/forms";
import * as i7 from "../../loaders/loading-symbol/loading-symbol.component";
import * as i8 from "../modal-base/components/modal-base.component";
import * as i9 from "../modal-base/components/simple-modal-header.component";
import * as i10 from "../../dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = () => ({ button: "btn btn-secondary btn-block dropdown-toggle style-underline" });
function SharingModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 11);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loaderMessage", ctx_r0.loadingMessage);
} }
function SharingModalComponent_div_4_ycn_single_select_dropdown_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 18);
    i0.ɵɵlistener("changeHandler", function SharingModalComponent_div_4_ycn_single_select_dropdown_3_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.handleGroupChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", ctx_r0.groupDropdownConfig)("customCssClasses", i0.ɵɵpureFunction0(3, _c0))("selectedValue", ctx_r0.state.selectedGroupValue);
} }
function SharingModalComponent_div_4_ycn_single_select_dropdown_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 18);
    i0.ɵɵlistener("changeHandler", function SharingModalComponent_div_4_ycn_single_select_dropdown_5_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.handlePermissionChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", ctx_r0.permissionDropdownConfig)("customCssClasses", i0.ɵɵpureFunction0(3, _c0))("selectedValue", ctx_r0.state.selectedSharingValue);
} }
function SharingModalComponent_div_4_div_6_textarea_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 26);
    i0.ɵɵtwoWayListener("ngModelChange", function SharingModalComponent_div_4_div_6_textarea_8_Template_textarea_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r0.notificationMessage, $event) || (ctx_r0.notificationMessage = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtext(1, "                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.notificationMessage);
} }
function SharingModalComponent_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵtext(2, "Custom Text");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 21)(4, "input", 22);
    i0.ɵɵlistener("click", function SharingModalComponent_div_4_div_6_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.toggleSendNotifications()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 23);
    i0.ɵɵelementStart(6, "span", 24);
    i0.ɵɵtext(7, "Notify people");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, SharingModalComponent_div_4_div_6_textarea_8_Template, 2, 1, "textarea", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r0.sendNotifications);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.sendNotifications);
} }
function SharingModalComponent_div_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
} }
function SharingModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "div", 14);
    i0.ɵɵtemplate(3, SharingModalComponent_div_4_ycn_single_select_dropdown_3_Template, 1, 4, "ycn-single-select-dropdown", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵtemplate(5, SharingModalComponent_div_4_ycn_single_select_dropdown_5_Template, 1, 4, "ycn-single-select-dropdown", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, SharingModalComponent_div_4_div_6_Template, 9, 2, "div", 16)(7, SharingModalComponent_div_4_div_7_Template, 1, 0, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.groupDropdownConfig.list.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.permissionDropdownConfig.list.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showNotificationForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.groupDropdownConfig.list.length > 0 && ctx_r0.permissionDropdownConfig.list.length > 0);
} }
const MARKED_FOR_PUBLIC_SHARING_PERMISSION_CONFIG = {
    list: [
        {
            value: PublicSharingState.MARKED_FOR_SHARING,
            label: 'Publish to Public',
            description: 'Everyone at YCharts can view and download',
        },
        {
            value: PublicSharingState.NOT_SHARED,
            label: 'Cancel Publish',
            description: 'Cancel request to publish to public',
        },
    ],
};
const PUBLIC_SHARING_PERMISSION_CONFIG = {
    list: [
        {
            value: PublicSharingState.MARKED_FOR_SHARING,
            label: 'Publish to Public',
            description: 'Everyone at YCharts can view and download',
        },
        {
            value: NO_VIEW,
            label: 'Cannot View',
            description: 'People cannot view or edit',
        },
    ],
};
const MARKED_FOR_PUBLIC_UNSHARING_PERMISSION_CONFIG = {
    list: [
        {
            value: PublicSharingState.MARKED_FOR_UNSHARING,
            label: 'Unpublish from Public',
            description: 'Not everyone at YCharts can view and download',
        },
        {
            value: PublicSharingState.SHARED,
            label: 'Cancel Unpublish',
            description: 'Cancel request to unpublish from public',
        },
    ],
};
const PUBLIC_UNSHARING_PERMISSION_CONFIG = {
    list: [
        {
            value: PublicSharingState.MARKED_FOR_UNSHARING,
            label: 'Unpublish from Public',
            description: 'Not everyone at YCharts can view and download',
        },
        {
            value: PublicSharingState.SHARED,
            label: 'Publish to Public',
            description: 'Everyone at YCharts can view and download',
        },
    ],
};
const PRIVATE_SHARING_PERMISSION_CONFIG = {
    list: [
        { value: VIEW, label: 'Can View', description: 'People can view and download' },
        { value: EDIT, label: 'Can Edit', description: 'People can edit' },
        { value: NO_VIEW, label: 'Cannot View', description: 'People cannot view or edit' },
    ],
};
const VIEW_ONLY_PRIVATE_SHARING_PERMISSION_CONFIG = {
    list: [
        { value: VIEW, label: 'Can View', description: 'People can view and download' },
        { value: NO_VIEW, label: 'Cannot View', description: 'People cannot view or edit' },
    ],
};
/**
 * A map of current public sharing states to valid states that can be transitioned to.
 */
const CURR_TO_TARGET_STATE = {
    [PublicSharingState.SHARED]: PublicSharingState.MARKED_FOR_UNSHARING,
    [PublicSharingState.MARKED_FOR_UNSHARING]: PublicSharingState.SHARED,
    [PublicSharingState.NOT_SHARED]: PublicSharingState.MARKED_FOR_SHARING,
    [PublicSharingState.MARKED_FOR_SHARING]: PublicSharingState.NOT_SHARED,
};
/**
 * Sharing Modal Component
 *
 * A modal that allows users to share items with private or public client groups.
 *
 * Inputs:
 *   shareableItem
 *   excludeEditPermission
 *   fetchConfirmUnshareMessage
 *   publicSharingItemType
 *
 * Outputs:
 *   closeModalHandler
 *   completeHandler
 *
 *
 * Example: Item that is publicly shareable
 * <ycn-sharing-modal
 *   *ngIf="selectedItem"
 *   [shareableItem]="selectedItem"
 *   [publicSharingItemType]="'custom_security'"
 *   (closeModalHandler)="resetModalState()"
 *   (completeHandler)="handleComplete()"
 * ></ycn-sharing-modal>
 *
 * Example: Item that is not publicly shareable
 * <ycn-sharing-modal
 *       *ngIf="selectedItem"
 *       [shareableItem]=selectedItem>
 * </ycn-sharing-modal>
 */
export class SharingModalComponent {
    get itemIsPubliclyShared() {
        if (this.shareableItem?.id === null || this.shareableItem?.id === undefined) {
            return false;
        }
        return (isPublicShareableItem(this.shareableItem) &&
            !!this.currPublicSharingState &&
            this.currPublicSharingState !== PublicSharingState.NOT_SHARED);
    }
    constructor(sharingService, toastService, cdr) {
        this.sharingService = sharingService;
        this.toastService = toastService;
        this.cdr = cdr;
        /**
         * Whether to exclude the edit option in the permissions dropdown.
         * Useful when sharing items that can never be edited by users they are shared with (ex: dashboards)
         */
        this.excludeEditPermission = false;
        /**
         * The type of item that supports public sharing. An empty string means the item does not
         * support public sharing.
         */
        this.publicSharingItemType = '';
        /**
         * Whether to also create DashboardTab entries for all group members when sharing.
         * Only applicable when sharing Dashboards via "Share & Publish".
         */
        this.publishToTabs = false;
        /**
         * Emits when the modal is closed.
         */
        this.closeModalHandler = new EventEmitter();
        /**
         * Emits when the submit button is clicked.
         */
        this.completeHandler = new EventEmitter();
        this.USER = window.USER;
        this.state = {
            modalOpen: false,
            validChanges: false,
            errorMessage: '',
            originalGroupValue: -1,
            selectedGroupValue: -1,
            originalSharingValue: NO_VIEW,
            selectedSharingValue: NO_VIEW,
        };
        this.sharedItems = [];
        this.shareGroups = [];
        this.currPublicSharingState = '';
        /**
         * Dropdowns
         */
        this.permissionDropdownConfig = { ...PRIVATE_SHARING_PERMISSION_CONFIG };
        this.groupDropdownConfig = {
            list: [],
        };
        /**
         * Loading
         */
        this.loading = false;
        this.loadingMessage = 'Loading...';
        /**
         * Private Sharing
         */
        this.sendNotifications = true;
        this.showNotificationForm = false;
        this.notificationMessage = null;
        this.confirmUnshareMessage = '';
        // todo: This subject appears to be used to propagate errors to the subscription in submit().
        //  - refactor to use rxjs side effects (ex: pipe and tap)
        //  - remove this subject
        //  - simplify handlePrivateSharingSubmit() to call handlers instead of duplicating logic.
        this.unshare$ = new Subject();
        // default set to a non-action function since we cannot invoke an object which is possibly 'null' in the template
        this.confirmUnshareCallback = () => { };
    }
    get itemId() {
        return this.shareableItem ? this.shareableItem.id : -1;
    }
    get itemType() {
        return this.shareableItem ? this.shareableItem.sharing.type : '';
    }
    get canSharePublicly() {
        return this.shareableItem
            ? !!this.publicSharingItemType &&
                isPublicShareableItem(this.shareableItem) &&
                this.USER.hasPublicSharingAccess
            : false;
    }
    /**
     * Shows the modal to the user.
     *
     * Note: Make requests only after the user has opened the modal for performance reasons,
     * as well as to prevent bugs when an item's permission changes through means other than the sharing modal
     * (e.g. when a child is automatically shared)
     */
    openModal() {
        if (window.USER.shareableClientGroups.length === 0) {
            const errorMessage = 'You do not have any client groups to share with. Please contact support.';
            this.configureModalForError(errorMessage);
            this.state.modalOpen = true;
            return;
        }
        if (!this.canSharePublicly) {
            this.configureModalForPrivateItem();
            this.state.modalOpen = true;
            return;
        }
        let publicShareGroupId;
        this.sharingService.getPublicSharingState(this.shareableItem.id, this.publicSharingItemType).subscribe({
            next: (data) => {
                const { public_sharing_state: publicSharingState, public_share_group_id } = data;
                this.currPublicSharingState = publicSharingState;
                publicShareGroupId = public_share_group_id;
            },
            error: (error) => {
                this.handleAjaxError(error);
                this.configureModalForError(this.state.errorMessage);
                this.cdr.markForCheck();
            },
            complete: () => {
                if (this.itemIsPubliclyShared) {
                    if (this.canSharePublicly) {
                        this.configureModalForPublicItem(publicShareGroupId);
                    }
                    else {
                        this.configureModalForError("The public sharing feature is required to edit a public item's sharing " +
                            'settings. Please try again or contact support.');
                    }
                }
                else {
                    this.configureModalForPrivateItem();
                }
                this.state.modalOpen = true;
                this.cdr.markForCheck();
            },
        });
    }
    closeModal() {
        // Reset the state of the modal
        this.state = {
            ...this.state,
            modalOpen: false,
            validChanges: false,
            errorMessage: '',
        };
        this.sharedItems = [];
        this.shareGroups = [];
        this.loading = false;
        this.loadingMessage = 'Loading...';
        this.notificationMessage = null;
        this.sendNotifications = true;
        this.showNotificationForm = false;
        this.confirmUnshareMessage = '';
        this.closeModalHandler.emit();
    }
    /**
     * Dropdown Configuration
     */
    configureModalForError(errorMessage) {
        this.state.errorMessage = errorMessage;
        this.state.originalGroupValue = -1;
        this.state.selectedGroupValue = -1;
        this.state.originalSharingValue = '';
        this.state.selectedSharingValue = '';
        this.groupDropdownConfig = { list: [] };
        this.permissionDropdownConfig = { list: [] };
    }
    configureModalForPublicItem(selectedGroupId = null) {
        this.state.originalGroupValue = selectedGroupId || -1;
        this.state.selectedGroupValue = selectedGroupId || -1;
        this.state.originalSharingValue = this.currPublicSharingState;
        this.state.selectedSharingValue = this.currPublicSharingState;
        this.setGroupDropdownConfig();
        this.setPermissionDropdownConfig();
    }
    /**
     * GETs the unshared or privately shared item, and uses the info to initialize the component state
     */
    configureModalForPrivateItem() {
        this.loading = true;
        this.loadingMessage = 'Loading...';
        const shareableItem = this.shareableItem;
        this.sharingService
            .getSharedItem({
            item_type: shareableItem.sharing.type,
            item_id: shareableItem.id,
        })
            .subscribe({
            next: (data) => {
                this.sharedItems = data;
                this.shareGroups = this.sharedItems.filter((item) => item.permission !== NO_VIEW);
                if (this.shareGroups.length > 0) {
                    // already shared with a group
                    this.state.originalGroupValue = this.shareGroups[0].client_group_id;
                    this.state.selectedGroupValue = this.shareGroups[0].client_group_id;
                    this.state.originalSharingValue = this.shareGroups[0].permission;
                    this.state.selectedSharingValue = this.shareGroups[0].permission;
                }
                else {
                    // not yet shared with a group, select the first one by default
                    this.state.originalGroupValue = this.sharedItems[0].client_group_id;
                    this.state.selectedGroupValue = this.sharedItems[0].client_group_id;
                    this.state.originalSharingValue = NO_VIEW;
                    this.state.selectedSharingValue = NO_VIEW;
                }
                this.setGroupDropdownConfig();
                this.setPermissionDropdownConfig();
                this.loading = false;
                this.cdr.markForCheck();
            },
            error: (error) => {
                this.handleAjaxError(error);
                this.configureModalForError(this.state.errorMessage);
                this.loading = false;
                this.cdr.markForCheck();
            },
        });
    }
    setGroupDropdownConfig() {
        const dropdownConfig = { list: [] };
        // If the item is not shareable, then sharing is not allowed, so make the dropdown empty.
        // This is not expected to happen, but it acts as a safeguard and helps with typing.
        if (!Object.prototype.hasOwnProperty.call(this.shareableItem, 'sharing')) {
            this.groupDropdownConfig = dropdownConfig;
            return;
        }
        // If the item is minimally shareable, then only basic sharing permissions are allowed
        if (isMinimalShareableItem(this.shareableItem)) {
            dropdownConfig.list = this.getPrivateClientGroupConfigList();
            this.groupDropdownConfig = dropdownConfig;
            return;
        }
        // If the item is privately shared, then only private sharing permissions are allowed
        if (!this.itemIsPubliclyShared && this.shareGroups.length > 0) {
            dropdownConfig.list = this.getPrivateClientGroupConfigList();
        }
        // If the item is publicly shared and if the user has public sharing access,
        // then only public sharing permissions are allowed
        else if (this.itemIsPubliclyShared && this.canSharePublicly) {
            dropdownConfig.list = this.getPublicClientGroupConfigList();
        }
        // If the item is not shared, then private sharing permissions are allowed.
        // If the user has access, then public sharing permissions are also allowed.
        else {
            dropdownConfig.list = this.getPrivateClientGroupConfigList();
            // Place the public sharing option at the bottom of the list to avoid accidental selection
            if (this.canSharePublicly) {
                const publicClientGroups = this.getPublicClientGroupConfigList();
                if (publicClientGroups.length > 0) {
                    dropdownConfig.list.push({ type: 'divider', label: '', value: null });
                    dropdownConfig.list.push({
                        label: 'Public Share Groups',
                        value: null,
                        disabled: true,
                    });
                    dropdownConfig.list = dropdownConfig.list.concat(publicClientGroups);
                }
            }
        }
        // Update the dropdown config
        this.groupDropdownConfig = dropdownConfig;
    }
    /**
     * Returns a list of private client groups for the dropdown.
     */
    getPrivateClientGroupConfigList() {
        return this.sharedItems.map((item) => {
            return {
                value: item.client_group_id,
                label: item.client_group_name,
            };
        });
    }
    /**
     * Returns a list of public client groups for the dropdown.
     */
    getPublicClientGroupConfigList() {
        const sharingStateValue = this.state.originalSharingValue in PublicSharingState
            ? this.state.originalSharingValue
            : this.currPublicSharingState;
        const validSharingState = sharingStateValue === PublicSharingState.NOT_SHARED;
        return this.USER.publicShareableClientGroups.map((item) => {
            return {
                value: item.id,
                label: item.name,
                disabled: !validSharingState && this.state.originalGroupValue !== item.id,
            };
        });
    }
    isPublicClientGroup(clientGroupId) {
        return this.USER.publicShareableClientGroups.some((publicCG) => publicCG.id === clientGroupId);
    }
    isCommunityClientGroup(clientGroupId) {
        const communities = this.USER.shareableCommunities ?? [];
        return communities.some((community) => community.id === clientGroupId);
    }
    /**
     * If the selected permission is invalid, set an appropriate permission based on the selected group.
     */
    validateSelectedPermission() {
        if (!isPublicShareableItem(this.shareableItem))
            return;
        this.state.selectedSharingValue =
            this.currPublicSharingState === PublicSharingState.NOT_SHARED ? NO_VIEW : this.currPublicSharingState;
    }
    setPermissionDropdownConfig() {
        if (this.isCommunityClientGroup(this.state.selectedGroupValue)) {
            this.permissionDropdownConfig = { ...VIEW_ONLY_PRIVATE_SHARING_PERMISSION_CONFIG };
            return;
        }
        // If sharing with a private client group or if the user does not have the public sharing feature,
        // show private sharing permissions
        if (!this.isPublicClientGroup(this.state.selectedGroupValue) ||
            !isPublicShareableItem(this.shareableItem) ||
            !this.USER.hasPublicSharingAccess) {
            this.permissionDropdownConfig = this.excludeEditPermission
                ? { ...VIEW_ONLY_PRIVATE_SHARING_PERMISSION_CONFIG }
                : { ...PRIVATE_SHARING_PERMISSION_CONFIG };
            return;
        }
        // If sharing with a public client group, show public sharing permissions
        // with language based on the current state
        switch (this.currPublicSharingState) {
            case PublicSharingState.NOT_SHARED:
                this.permissionDropdownConfig = { ...PUBLIC_SHARING_PERMISSION_CONFIG };
                break;
            case PublicSharingState.MARKED_FOR_SHARING:
                this.permissionDropdownConfig = { ...MARKED_FOR_PUBLIC_SHARING_PERMISSION_CONFIG };
                break;
            case PublicSharingState.SHARED:
                this.permissionDropdownConfig = { ...PUBLIC_UNSHARING_PERMISSION_CONFIG };
                break;
            case PublicSharingState.MARKED_FOR_UNSHARING:
                this.permissionDropdownConfig = { ...MARKED_FOR_PUBLIC_UNSHARING_PERMISSION_CONFIG };
                break;
            default:
                this.configureModalForError("This item's sharing settings cannot be edited at this time.");
        }
    }
    /**
     * Dropdown Change Handlers
     */
    handleGroupChange(selectedGroupValue) {
        // Set the component state
        this.state.selectedGroupValue = selectedGroupValue;
        this.state.validChanges = true;
        // Display permissions for the type of selected client group (private or public)
        this.setPermissionDropdownConfig();
        this.validateSelectedPermission();
        // Determine whether to show the notification form
        this.setShowNotificationForm();
    }
    handlePermissionChange(selectedPermission) {
        // Set the component state
        this.state.selectedSharingValue = selectedPermission;
        this.state.validChanges = true;
        // Determine whether to show the notification form
        this.setShowNotificationForm();
    }
    /**
     * Submit
     */
    submit() {
        this.loading = true;
        this.loadingMessage = 'Updating Preferences...';
        const unshareMessageCallback$ = this.fetchConfirmUnshareMessage ? this.fetchConfirmUnshareMessage() : of('');
        unshareMessageCallback$
            .pipe(switchMap((confirmUnshareMessage) => {
            this.confirmUnshareMessage = confirmUnshareMessage;
            return this.handleSubmit();
        }))
            .subscribe({
            next: (response) => {
                this.showToastMessage(response);
                this.closeModal();
                this.loading = false;
                this.completeHandler.emit();
                this.cdr.markForCheck();
            },
            error: (error) => {
                this.handleAjaxError(error);
                this.loading = false;
                this.cdr.markForCheck();
            },
        });
    }
    showToastMessage(response) {
        if (!response || !this.hasChanged())
            return;
        let message = '';
        const { selectedGroupValue, selectedSharingValue: sharingValue } = this.state;
        const responseGroup = this.groupDropdownConfig.list.find((g) => g.value === selectedGroupValue);
        const groupName = responseGroup?.label || '';
        const itemName = this.shareableItem.name;
        if (typeof response === 'object' && 'message' in response) {
            const regex = /^Item\b/;
            message = response.message.replace(regex, `"${itemName}"`);
        }
        else if (sharingValue === NO_VIEW) {
            message = `"${itemName}" was unshared successfully from the ${groupName} group.`;
        }
        else {
            message = `"${itemName}" was shared successfully to the ${groupName} group with ${sharingValue} permission.`;
        }
        this.toastService.addMessage(message);
    }
    hasChanged() {
        const { originalGroupValue, selectedGroupValue, originalSharingValue, selectedSharingValue } = this.state;
        return (!(originalSharingValue === NO_VIEW && selectedSharingValue === NO_VIEW) &&
            (originalGroupValue !== selectedGroupValue || originalSharingValue !== selectedSharingValue));
    }
    handleSubmit() {
        // nothing to change, resolve to empty observable
        if (!this.hasChanged())
            return of([]);
        if (this.isPublicClientGroup(this.state.selectedGroupValue))
            return this.handlePublicSharingSubmit();
        return this.handlePrivateSharingSubmit();
    }
    /**
     * Handles changing the public sharing state of a publicly shareable item.
     */
    handlePublicSharingSubmit() {
        if (!isPublicShareableItem(this.shareableItem) || !this.publicSharingItemType) {
            throw new Error('Item is not publicly shareable');
        }
        const publicShareGroupId = this.state.selectedGroupValue;
        if (!this.isPublicClientGroup(publicShareGroupId)) {
            throw new Error('Selected share group is not a public group');
        }
        const { id } = this.shareableItem;
        const targetState = CURR_TO_TARGET_STATE[this.currPublicSharingState];
        return this.sharingService.changePublicSharingState(id, this.publicSharingItemType, targetState, publicShareGroupId);
    }
    /**
     * Handles the private sharing logic of POST / PUT / DELETE ing
     * based on the original group / permission and the selected group / permission.
     */
    handlePrivateSharingSubmit() {
        const originalGroupValue = this.state.originalGroupValue;
        const selectedGroupValue = this.state.selectedGroupValue;
        const originalPermission = this.state.originalSharingValue;
        const selectedPermission = this.state.selectedSharingValue;
        const postParams = {
            client_group_id: selectedGroupValue,
            permission: selectedPermission,
            send_notifications: this.sendNotifications,
            notification_message: this.notificationMessage,
            publish_to_tabs: this.publishToTabs,
        };
        // Share - create a shared item
        if (originalPermission === NO_VIEW && selectedPermission !== NO_VIEW) {
            // POST (no_view --> view/edit)
            return this.sharingService.postSharedItem({
                item_type: this.itemType,
                item_id: this.itemId,
            }, postParams);
        }
        // Unshare - delete a shared item
        if (originalPermission !== NO_VIEW &&
            selectedPermission === NO_VIEW &&
            originalGroupValue === selectedGroupValue) {
            // Handle through confirm modal callback
            if (this.confirmUnshareMessage) {
                // Show confirm modal with warning message
                this.confirmUnshareCallback = this.handleDeletePrivateSharedItem;
                this.confirmUnshareModal.openModal();
                return this.unshare$;
            }
            // Handle without confirm modal
            return this.sharingService.deleteSharedItem({
                item_type: this.itemType,
                item_id: this.itemId,
                client_group_id: originalGroupValue,
            });
        }
        const itemIsAlreadyShared = originalPermission !== NO_VIEW && selectedPermission !== NO_VIEW;
        // Item is already shared - change the group's permission to the shared item
        if (itemIsAlreadyShared && selectedGroupValue === originalGroupValue) {
            return this.sharingService.putSharedItem({
                item_type: this.itemType,
                item_id: this.itemId,
                client_group_id: selectedGroupValue,
            }, { permission: selectedPermission });
        }
        // Item is already shared - change the group with which the item is shared
        if (itemIsAlreadyShared && selectedGroupValue !== originalGroupValue) {
            // Handle through confirm modal callback
            if (this.confirmUnshareMessage) {
                // Show confirm modal with warning message
                this.confirmUnshareCallback = this.handlePrivateClientGroupChange;
                this.confirmUnshareModal.openModal();
                return this.unshare$;
            }
            // Handle without confirm modal
            return this.sharingService.changeSharedClientGroup({ item_type: this.itemType, item_id: this.itemId, client_group_id: originalGroupValue }, {
                new_client_group_id: selectedGroupValue,
                permission: selectedPermission,
                send_notifications: this.sendNotifications,
                notification_message: this.notificationMessage,
            });
        }
        // This should never run, as all cases are caught above
        return throwError('');
    }
    /**
     * Callback for the confirm modal when we are deleting a privately shared item (view/edit -> no_view)
     */
    handleDeletePrivateSharedItem(confirmed) {
        if (confirmed) {
            this.sharingService
                .deleteSharedItem({
                item_type: this.itemType,
                item_id: this.itemId,
                client_group_id: this.state.originalGroupValue,
            })
                .subscribe({
                next: () => this.unshare$.next(), // DELETE succeeded,
                error: (e) => this.unshare$.error(e), // DELETE errored
            });
        }
        else {
            // User declined confirmation, so resolve because nothing went wrong
            this.unshare$.next();
        }
    }
    /**
     * Callback for the confirm modal when we are changing the shared item's group (Group A -> Group B).
     *
     * This request causes the existing shared item to be deleted, and then a new shared item to be created.
     * This approach prevents a state where an item is shared with multiple groups at the same time.
     */
    handlePrivateClientGroupChange(confirmed) {
        if (confirmed) {
            this.sharingService
                .changeSharedClientGroup({
                item_type: this.itemType,
                item_id: this.itemId,
                client_group_id: this.state.originalGroupValue,
            }, {
                new_client_group_id: this.state.selectedGroupValue,
                permission: this.state.selectedSharingValue,
                send_notifications: this.sendNotifications,
                notification_message: this.notificationMessage,
            })
                .subscribe({
                next: () => this.unshare$.next(), // DELETE then POST succeeded
                error: (e) => this.unshare$.error(e), // DELETE then POST failed
            });
        }
        else {
            // User declined confirmation, so resolve because nothing went wrong
            this.unshare$.next();
        }
    }
    handleAjaxError(errorResponse) {
        const defaultMessage = 'Error. Please try again or contact us with details of your problem.';
        // Set the error message depending on the error code returned from the backend.
        switch (errorResponse.status) {
            case 404:
            case 403:
                const errorMessage = errorResponse.error;
                // Check if the error message is an empty string, empty array, or falsy value
                if (!errorMessage || (Array.isArray(errorMessage) && errorMessage.length === 0)) {
                    this.state.errorMessage = defaultMessage;
                }
                else {
                    this.state.errorMessage = errorMessage;
                }
                break;
            default:
                this.state.errorMessage = defaultMessage;
        }
    }
    /**
     * Notifications
     */
    toggleSendNotifications() {
        this.sendNotifications = !this.sendNotifications;
    }
    /**
     * Determine whether the notification form should show.
     */
    setShowNotificationForm() {
        const { originalGroupValue, selectedGroupValue, originalSharingValue, selectedSharingValue } = this.state;
        const sharingIsPublic = this.isPublicClientGroup(selectedGroupValue);
        const selectedOptionsChanged = originalGroupValue !== selectedGroupValue || originalSharingValue !== selectedSharingValue;
        const newPermissionAllowsViewing = selectedSharingValue !== NO_VIEW;
        this.showNotificationForm = !sharingIsPublic && selectedOptionsChanged && newPermissionAllowsViewing;
    }
}
SharingModalComponent.ɵfac = function SharingModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SharingModalComponent)(i0.ɵɵdirectiveInject(i1.SharingService), i0.ɵɵdirectiveInject(i2.PageToastMessagesService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SharingModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SharingModalComponent, selectors: [["ycn-sharing-modal"]], viewQuery: function SharingModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmUnshareModal = _t.first);
    } }, inputs: { shareableItem: "shareableItem", excludeEditPermission: "excludeEditPermission", publicSharingItemType: "publicSharingItemType", fetchConfirmUnshareMessage: "fetchConfirmUnshareMessage", publishToTabs: "publishToTabs" }, outputs: { closeModalHandler: "closeModalHandler", completeHandler: "completeHandler" }, standalone: false, decls: 12, vars: 10, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [1, "modal-footer"], [1, "modal-footer-info"], [1, "text-red", 3, "textContent"], [1, "modal-footer-actions"], ["ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"], [3, "loaderMessage"], [1, "modal-section"], [1, "row", "form-row"], [1, "col"], [3, "config", "customCssClasses", "selectedValue", "changeHandler", 4, "ngIf"], ["class", "form-row", 4, "ngIf"], ["class", "divider-horizontal", 4, "ngIf"], [3, "changeHandler", "config", "customCssClasses", "selectedValue"], [1, "form-row"], [1, "mt-2", "text-bold"], [1, "custom-control", "custom-checkbox", "mb-1"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], ["type", "text", "rows", "1", "class", "form-control", "placeholder", "Enter custom text...", 3, "ngModel", "ngModelChange", 4, "ngIf"], ["type", "text", "rows", "1", "placeholder", "Enter custom text...", 1, "form-control", 3, "ngModelChange", "ngModel"], [1, "divider-horizontal"]], template: function SharingModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function SharingModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function SharingModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, SharingModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 3)(4, SharingModalComponent_div_4_Template, 8, 4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵelement(7, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8)(9, "div", 9);
        i0.ɵɵlistener("click", function SharingModalComponent_Template_div_click_9_listener() { return ctx.submit(); });
        i0.ɵɵtext(10, " OK ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(11, "ycn-confirm-modal", 10);
        i0.ɵɵlistener("confirmHandler", function SharingModalComponent_Template_ycn_confirm_modal_confirmHandler_11_listener($event) { return ctx.confirmUnshareCallback($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.state.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Share " + ctx.shareableItem.name + (ctx.itemIsPubliclyShared ? " publicly" : "") + " with");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.shareableItem);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.state.errorMessage);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.loading || !ctx.state.validChanges);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Unshare")("confirmHeader", "Unshare Item")("confirmText", ctx.confirmUnshareMessage);
    } }, dependencies: [i3.NgIf, i4.ConfirmModalComponent, i5.DisabledDirective, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgModel, i7.LoadingSymbolComponent, i8.ModalBaseComponent, i9.SimpleModalHeaderComponent, i10.SingleSelectDropdownComponent], encapsulation: 2 });
